import { Component, OnInit, ElementRef, Injectable, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormDataService } from 'src/app/shared/form-data.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { NgbDateStruct, NgbCalendar, NgbDatepickerConfig, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'underscore';
import EcUtils from '../../shared/ecutils';
import { ConfigService } from 'src/app/shared/config.service';

import { PagerService } from 'src/app/shared/pager.service';
import { ToastrService } from 'ngx-toastr';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/main/modal/modal.component';
import * as internal from 'assert';
//import { MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day.toString().padStart(2, '0') + this.DELIMITER + date.month.toString().padStart(2, '0') + this.DELIMITER + date.year : null;
  }
}

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class QuestionsComponent implements OnInit, OnDestroy {

  questions = [];
  answers = [];
  questionsForm: FormGroup;
  // pager object
  pager: any = {};

  // paged items
  pagedItems: any[];
  contentDetail: any;
  errorMsg: string;
  enableSubmitBtn: boolean;
  isEasyClaimTlAcceptType: boolean;
  damageConditions: any[];
  directionOfImpacts: any[];
  maxDate = new Date();
  selectedValue = "Select";
  directionOfImpactValue = "";
  investigationType = "";
  stpDelay: Number;
  showcbTermsConditions: boolean;
  airbagNames: string[] = [];
  isAnswersValid: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formDataService: FormDataService,
    private pagerService: PagerService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private configService: ConfigService,
    public matDialog: MatDialog,
    private el: ElementRef,
    private config: NgbDatepickerConfig
    //public dialogRef: MatDialogRef<ModalComponent>
  ) {
    this.contentDetail = this.configService.config.Data.contentDetail;
    this.errorMsg = "";
    this.isEasyClaimTlAcceptType = this.formDataService.getIsEasyClaimTlAcceptType();
    this.enableSubmitBtn = true;

    if (this.isEasyClaimTlAcceptType == true) {
      this.enableSubmitBtn = false;

      var showTLAcceptCb = this.contentDetail.ShowTLAcceptCb.toLowerCase();
      if (showTLAcceptCb == "yes") {
        this.showcbTermsConditions = true;
      }
      else {
        this.showcbTermsConditions = false;
        this.enableSubmitBtn = true;
      }
    }

    this.damageConditions = this.configService.config.Data.DamageConditions;
    this.directionOfImpacts = this.configService.config.Data.DirectionOfImapcts;

    const current = new Date();
    config.maxDate = {
      year: current.getFullYear(), month:
        current.getMonth() + 1, day: current.getDate()
    };

    this.investigationType = this.configService.config.Data.Investigation_type;
    this.stpDelay = this.configService.config.Data.STPDelay;
    this.isAnswersValid = true;
  }
  private unsubscribe$ = new Subject<void>();
  ngOnInit() {
    var photoEl = this.el.nativeElement.parentElement.parentElement.childNodes[0].childNodes[0];
    if (photoEl != null) {
      photoEl.classList.remove("disableCls");
    }

    this.questionsForm = this.formBuilder.group({});
    this.questions = this.formDataService.getPhase1Questions();

    var easyClaimType = this.formDataService.getEasyClaimType();
    if (easyClaimType == "EasyClaimTL") {
      var filterString = "";
      if (this.isEasyClaimTlAcceptType == true) {
        filterString = "accept";
      }
      else {
        filterString = "decline";
      }

      this.questions = this.questions.filter(x => x.AcceptDeclineType == filterString);
    }

    let vrn = localStorage.getItem("vrn");
    let odometer = localStorage.getItem("odometer");
    let accidentDate = localStorage.getItem("accidentDate");

    this.questions.forEach((q, i) => {
      if (vrn != "" && q.question_type === "vrn") q.Answer = vrn
      if (odometer != "" && q.question_type === "odometer") q.Answer = odometer;
      if (accidentDate != "" &&q.question_type === "incident_date") {
        let dateOnly = accidentDate.split(" ")[0];
        let dateOnlyArr = dateOnly.split("/");
        q.Answer = `${dateOnlyArr[1]}-${dateOnlyArr[0]}-${dateOnlyArr[2]}`
      }

      const fc: FormControl = new FormControl(q.Answer);
      this.questionsForm.addControl(q.qn_number, fc);
      if (q.answer_type === 'free_text') {
            fc.valueChanges
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((value: string) => {
                this.invalidCharErrors[q.qn_number] = value ? !this.noHtmlPattern.test(value) : false;
              });
          }
    });
    this.setPage(1);
  }
  private readonly noHtmlPattern = /^[^<>]*$/;

  public invalidCharErrors: { [qnNumber: string]: boolean } = {};

  onFreeTextInput(question: any, event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    console.log('Input value:', value);
    this.invalidCharErrors[question.qn_number] = value ? !this.noHtmlPattern.test(value) : false;
  }

  private sanitizeInput(value: string): string {
    if (!value) return value;
    return value
      .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '') // remove script blocks entirely
      .replace(/<\/?[^>]+(>|$)/g, '')                     // strip remaining tags
      .trim();
  }
  

ngOnDestroy() {
  this.unsubscribe$.next();   // ← this fires the "stop" signal
  this.unsubscribe$.complete();
}
  bindAnswers() {
    Object.keys(this.questionsForm.controls).forEach(key => {
      this.questions.forEach((q, i) => {
        if (q.qn_number === key) {
          if (q.answer_type === 'date') {
            //q.Answer = EcUtils.format(this.questionsForm.controls[key].value);
            var dateVal = this.questionsForm.controls[key].value.split('-');
            q.Answer = dateVal[0].padStart(2, '0') + '-' + dateVal[1].padStart(2, '0') + '-' + dateVal[2];
          } else if (q.answer_type === 'dropdown') {
            if (q.question_type == 'direction_of_impact') {
              if (this.directionOfImpactValue != '') {
                q.Answer = this.directionOfImpactValue;
              }
            }
            else {
              q.Answer = this.questionsForm.controls[key].value === "select" ? "" : this.questionsForm.controls[key].value;
            }
          } else if (q.answer_type === 'free_number') {
            q.Answer = this.questionsForm.controls[key].value;
            if(this.isEasyClaimTlAcceptType){
              if(q.question_type == "account_number" && (q.Answer == null || q.Answer == "" || String(q.Answer).length != 8)){
                if(this.errorMsg != ""){
                  this.errorMsg += ", Account Number must be 8 numeric characters"
                }
                else{
                  this.errorMsg = "Account Number must be 8 numeric characters";
                }
                this.isAnswersValid = false;
              }
              else if(q.question_type == "sort_code" && (q.Answer == null || q.Answer == "" || String(q.Answer).length != 6)){
                if(this.errorMsg != ""){
                  this.errorMsg += ", Sort Code must be 6 numeric characters"
                }
                else{
                  this.errorMsg  = "Sort Code must be 6 numeric characters";
                }                
                this.isAnswersValid = false;
              }
            }

          } else if(q.answer_type === 'multiple_selection'){
              q.Answer = this.airbagNames.join();
          } else {
            const trimmed = this.questionsForm.controls[key].value.trim();
            if (!this.noHtmlPattern.test(trimmed)) {
              this.errorMsg = this.errorMsg
                ? this.errorMsg + `, ${q.question_text || 'This field'} contains invalid characters`
                : `${q.question_text || 'This field'} contains invalid characters`;
              this.isAnswersValid = false;
            }
            q.Answer = this.sanitizeInput(trimmed);
          }


        }
      });
    });

    if(this.isAnswersValid == false){
      return false;
    }
    return this.questions.every(q => {
      return ((q.is_required == 'no') || (q.is_required == 'yes' && q.Answer));
    });
  }


  photos() {
    this.bindAnswers();
    this.router.navigate(['../photos'], { relativeTo: this.route });
  }

  submit() {
    let isValid = this.bindAnswers();
    console.log('in submit ' + isValid);
    if (isValid) {

      //11
      // this.formDataService.setSubmitDateTime(new Date().toUTCString());
      // const http$ = this.formDataService.sendData();

      // this.openModal();
      // this.errorMsg = "";

      // http$.subscribe(res => {
      //   this.closeModal();
      //   this.formDataService.setTimeStampType("p1informationreceived");
      //   this.formDataService.setTimeStampDateTime(new Date().toUTCString());    

      //   const http$ = this.formDataService.submitTimeStamp();
      //   http$.subscribe(res => {

      //   }, err => {
      //     console.log(err);

      //   });



      //   if(res.IsError == true)
      //   {
      //     this.errorMsg = res.Messages[0].Message;
      //   }
      //   else
      //   {
      //     this.matDialog.afterAllClosed.subscribe(result => {

      //       if(this.investigationType.toLowerCase() == "automatic" && this.stpDelay != null)
      //       {
      //         const http$ = this.formDataService.sendAutomaticEmail();
      //         http$.subscribe(res => {

      //         }, err => {
      //           console.log(err);

      //         });
      //       }
      //     });

      //     this.formDataService.setEngineeringOutcome(res.EngineeringOutcome);


      //       this.router.navigate(['../response'], { relativeTo: this.route});
      //   }


      // }, err => {
      //   this.closeModal();
      //   console.log(err);
      //   this.errorMsg = "Your information was not able to be submitted. Please check your internet connection and try again";
      // });  

      //11

      //11 new Photo page changes
      this.formDataService.setTimeStampType("p1questionpagecontinuedate");
      this.formDataService.setTimeStampDateTime(new Date().toUTCString());

      const http$ = this.formDataService.submitTimeStamp();
      http$.subscribe(res => {

      }, err => {
        console.log(err);

      });

      this.router.navigate(['../photos'], { relativeTo: this.route });
      //11 new Photo page changes

    } else {
      this.closeModal();
      this.toastr.error('Please fill in required information.', 'Validation Error', {
        positionClass: 'toast-center-center',
        timeOut: 2000
      });

    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.questions.length, page, 10);

    // get current page of items
    this.pagedItems = this.questions.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }


  openModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "400px";
    dialogConfig.width = "500px";

    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
  }

  closeModal() {
    this.matDialog.closeAll();
  }

  enableSubmit(e) {
    if (e.target.checked) {
      this.enableSubmitBtn = true;
    }
    else {
      this.enableSubmitBtn = false;
    }
  }

  submitEasyClaimTlAccept() {
    this.errorMsg = "";
    this.isAnswersValid = true;
    let isValid = this.bindAnswers();
    if (isValid) {
      //11
      this.formDataService.setSubmitDateTime(new Date().toUTCString());
      const http$ = this.formDataService.submitEasyClaimTlAccept();

      this.openModal();
      this.errorMsg = "";

      http$.subscribe(res => {
        this.closeModal();
        this.formDataService.setTimeStampType("tlofferaccepted");
        this.formDataService.setTimeStampDateTime(new Date().toUTCString());

        const http$ = this.formDataService.submitTimeStamp();
        http$.subscribe(res => {

        }, err => {
          console.log(err);

        });

        if (res.IsError == true) {
          this.errorMsg = res.Messages[0].Message;
        }
        else {
          this.matDialog.afterAllClosed.subscribe(result => {

            if (this.investigationType.toLowerCase() == "automatic" && this.stpDelay != null) {
              const http$ = this.formDataService.sendAutomaticEmail();
              http$.subscribe(res => {

              }, err => {
                console.log(err);

              });
            }
          });


          this.router.navigate(['../response'], { relativeTo: this.route });
        }


      }, err => {
        this.closeModal();
        console.log(err);
        this.errorMsg = "Your information was not able to be submitted. Please check your internet connection and try again";
      });
      //11


    }
    else {
      this.closeModal();
      this.toastr.error('Please fill in required information.', 'Validation Error', {
        positionClass: 'toast-center-center',
        timeOut: 2000
      });

    }

  }

  setImpactDirection(directionOfImpact, directionOfImpactVal) {
    var divs = document.querySelectorAll(".vehicle-part");
    for (var i = 0; i < divs.length; i++) {
      divs[i].classList.remove('bg-green');
      divs[i].classList.add('bg-grey');
    }

    var currentDiv = document.getElementById(directionOfImpact) as HTMLElement;
    currentDiv.className += " bg-green";

    this.directionOfImpactValue = directionOfImpactVal;
  }

  setAirbagName(airbagElement, airbagVal)
  {
    var curAirbagDiv = document.getElementById(airbagElement) as HTMLElement;
    if(curAirbagDiv.classList.contains("bg-green"))
    {
      curAirbagDiv.classList.remove("bg-green");
      curAirbagDiv.classList.add("bg-grey");

      const airbagValIndex = this.airbagNames.indexOf(airbagVal, 0);
      if(airbagValIndex > -1)
      {
        this.airbagNames = this.airbagNames.splice(airbagValIndex,1);
      }
    }
    else
    {
      curAirbagDiv.classList.remove("bg-grey");
      curAirbagDiv.classList.add("bg-green");

      this.airbagNames.push(airbagVal);
    }
    

    
  }
}
